import { FC } from 'react';

import { Energimerke, Energimerkeversjon } from '../../types/energimerke';

import { EnergikarakterV2023 } from './v2023/energikarakterV2023';
import { EnergikarakterV2025 } from './v2025/energikarakterV2025';

export interface EnergimerkeProps {
  energimerke: Energimerke;
}

export const Energikarakter: FC<EnergimerkeProps> = ({ energimerke }) => {
  switch (energimerke?.version) {
    case Energimerkeversjon.V2025:
      return <EnergikarakterV2025 energimerke={energimerke} />;
    case Energimerkeversjon.V2023:
      return <EnergikarakterV2023 energimerke={energimerke} />;
    default:
      // TODO: Decide how to handle unsupported versions
      console.warn('Unsupported energimerke version');
      return <EnergikarakterV2023 energimerke={energimerke} />;
  }
};
